import React from "react";

const Title = ({ title }) => {
  return (
    <div className="section-title text-center pb-50">
      <h2>{title}</h2>
    </div>
  );
};

export default Title;
